export function join(items, separator=`, `, lastSeparator=` and `) {
  if (!items?.length) return ``;

  let last = items[items.length - 1];
  let rest = items.slice(0, -1);

  return `${rest.join(separator)}${rest.length ? lastSeparator : ``}${last}`;
}
